/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Search/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import * as fromHelpers from './helpers.js'
import No from './No/index'
import Preview from './Preview/index'
import React from 'react'
import SearchBar from './SearchBar/index'



/** @type {import('Simple/types.js').View} */
export default function Search({
  children,
  viewPath = "/App/Account/Content/Calendar/New/AppointmentOverlay/Content/Old/PatientSelect/Content/Content/New/ReferralSource/Content/Referrals/Referral/Source/Search"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'No'
let referralValueData = fromData.useDataFormat({ viewPath,
context: 'referral',
format: fromHelpers.getView,
})
fromData.useSetFlowToBasedOnDataValue({ viewPath,
value: referralValueData,
})
  return (<React.Fragment
>
<fromFlow.When is={flowValue === 'No'}>
<No
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'SearchBar'}>
<SearchBar
  viewPath={`${viewPath}/SearchBar`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Preview'}>
<Preview
  viewPath={`${viewPath}/Preview`}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}